import { InjectionToken } from '@angular/core';
import {
  MojoShareResourceAutocompleteService,
  MojoShareResourceService,
  MojoTeamMemberService,
} from 'mojo-share-resource';

export const SHARE_RESOURCE_SERVICE = new InjectionToken<MojoShareResourceService>(
  'MojoShareResourceService',
);
export const SHARE_RESOURCE_AUTOCOMPLETE_SERVICE =
  new InjectionToken<MojoShareResourceAutocompleteService>('MojoAutocompleteService');

export const SHARE_TEAM_MEMBER_SERVICE = new InjectionToken<MojoTeamMemberService>(
  'MojoTeamMemberService',
);
